import { render, staticRenderFns } from "./AddEntityModal.vue?vue&type=template&id=60220e20&scoped=true&"
import script from "./AddEntityModal.vue?vue&type=script&lang=js&"
export * from "./AddEntityModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEntityModal.vue?vue&type=style&index=0&id=60220e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60220e20",
  null
  
)

export default component.exports